<template>
  <div>
    <v-row
      class="primary filter-list-header"
      elevation="4">
      <code class="ma-2 white filter-list-header-title pt-1">
        <h2>รายการ Filter</h2>
      </code>
      <v-spacer />
      <v-btn
        color="error"
        class="ma-2"
        @click="reQuery">
        ReQuery
      </v-btn>
      <v-btn
        color="success"
        class="ma-2"
        @click="$router.push({ name: 'CreateFilter' })">
        สร้าง Filter
      </v-btn>
    </v-row>
    <v-row justify="space-around">
      <v-sheet
        width="100%"
        elevation="4"
        class="pb-10 px-6">
        <v-row justify="center">
          <v-col class="d-flex justify-end py-0">
            <v-row justify="end">
              <v-col
                cols="2"
                class="d-flex justify-end py-0">
                <div class="text-h6 mt-5">
                  ค้นหา
                </div>
              </v-col>
              <v-col
                cols="3"
                class="py-0">
                <v-text-field
                  v-model="searchText"
                  @input="searchFilter" />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <filter-table
              :search-text="searchText"
              :init-filter="initFilter"
              @download-click="downloadClicked"
              @detail-click="detailClicked"
              @searched="() => initFilter = false" />
          </v-col>
        </v-row>
      </v-sheet>
    </v-row>
    <segment-list
      :display="showSegments"
      :filter-id="currentFilterId"
      @close="() => showSegments = false" />
    <filter-detail
      :display="showFilterDetail"
      :filter-id="currentFilterId"
      @close="() => showFilterDetail = false" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SchedulingProvider from '@/resources/SchedulingProvider'
import FilterTable from '../components/FilterTable.vue'
import SegmentList from '../components/SegmentList.vue'
import FilterDetail from '../components/FilterDetail.vue'

const schedulingService = new SchedulingProvider()
export default {
  components: {
    FilterTable,
    SegmentList,
    FilterDetail
  },
  data () {
    return {
      searchText: '',
      showSegments: false,
      showFilterDetail: false,
      searching: null,
      initFilter: false,
      currentFilterId: '',
      segmentOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [false],
        pageCount: 0,
        totalSegment: 0
      },
      segments: []
    }
  },
  watch: {
    options: {
      handler () {
        this.initFilter = true
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    searchFilter () {
      clearTimeout(this.searching)
      this.searching = setTimeout(() => {
        this.initFilter = true
      }, 1500)
    },
    downloadClicked (id) {
      this.currentFilterId = id
      setTimeout(() => { this.showSegments = true }, 500)
    },
    detailClicked (id) {
      this.currentFilterId = id
      setTimeout(() => { this.showFilterDetail = true }, 500)
    },
    reQuery () {
      schedulingService.reQuery()
    }
  }
}
</script>

<style scoped>
.filter-list-header {
  height: 50px;
}

.filter-list-header-title {
  border-radius: 10px;
  color: black !important;
}
</style>
